import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { Button, Loading } from '@cordata/buffet';

const LoadingModal = ({
  isOpen,
  toggle,
  headerText,
  message,
}) => (
  <Modal isOpen={isOpen} toggle={toggle}>
    <ModalHeader>
      {headerText}
    </ModalHeader>

    <ModalBody>
      <Loading message={message} />
    </ModalBody>

    <ModalFooter>
      <div className="ml-auto">
        <Button type="cancel" outline onClick={toggle}>
          Cancel
        </Button>
      </div>
    </ModalFooter>
  </Modal>
);

LoadingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  headerText: PropTypes.string,
  message: PropTypes.string,
};

LoadingModal.defaultProps = {
  headerText: 'Loading',
  message: undefined,
};

export default LoadingModal;
